const jsonRequest = async (url, options) => {
    const response = await fetch(url, options);
    const data = await response.json().catch(() => ({}));
    return { response, data };
};

export const loadPricingConfigResponses = () => Promise.all([
    fetch('/api/bundle-builder/config'),
    fetch('/api/bundle-builder/config/draft'),
    fetch('/api/bundle-builder/config/versions')
]);

export const loadTvPricingResponse = () => fetch('/api/tv-packages-v2/pricing').catch(() => null);

export const savePricingDraft = (config, scope, changeSummary) => jsonRequest(
    '/api/bundle-builder/config/draft',
    {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            config,
            ...(scope ? { scope } : {}),
            changeSummary
        })
    }
);

export const validatePricingDraft = (config) => jsonRequest(
    '/api/bundle-builder/config/validate',
    {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ config })
    }
);

export const publishPricingDraft = (scope, changeSummary) => jsonRequest(
    '/api/bundle-builder/config/publish',
    {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ change_summary: changeSummary, scope })
    }
);

export const rollbackPricingConfig = (scope, versionNumber, changeSummary) => jsonRequest(
    '/api/bundle-builder/config/rollback',
    {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            versionNumber,
            change_summary: changeSummary,
            scope
        })
    }
);
